import React, { useEffect, useState, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import {
  editOrganization,
  editDiscover,
  createDiscover,
  getOrganizationSettings,
  editOrganizationSettings,
} from "../../api/Organization";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import TextInput from "../../common/textfield/TextInput";
import CountrySelect from "../../common/textfield/CountrySelect";
import RegionSelect from "../../common/textfield/RegionSelect";
import TextArea from "../../common/textfield/TextArea";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  FormikObj,
  deviceUnitTypeOptions,
  devicesField,
  typeOfDeviceUnitTypeOptions,
  ORGANIZATION_DETAILS,
  PARENT_ORGANIZATION,
  NAME,
  DESCRIPTION,
  ADDRESS,
  COUNTRY,
  CITY,
  ZIP_CODE,
  POSTAL_CODE,
  PHONE_NUMBER,
  EXT,
  EMAIL_ADDRESS,
  APPOINTMENT_CANCEL_TIME,
  DEVICE_UNIT_TYPE,
  TYPE,
  CANCEL,
  UPDATE,
  operationTiming,
  transformTimingData,
  getDeviceUnit,
  getValidationSchema,
} from "./Constants";
import SelectFiled from "../../common/textfield/SelectFiled";
import {
  createContactNumber,
  splitContactNumber,
} from "../../../utils/phoneNumberSupport";
import InputFile from "../../common/textfield/InputFile";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import { useMedia } from "react-use";
import moment from "moment";
import GetCareSettings from "./GetCareSettings";
import { SurveySettings } from "./SurveySettings";
import {
  updateOrganizationLogo,
  updateOrganizationName,
} from "../../slice/authService";
import { useDispatch } from "react-redux";
import { useDiscoverIdQuery } from "../../../hooks/ReactQueryHooks/useDiscoverIdQuery";
import { ProductFeatures } from "./ProductFeatures";
import {
  useGetOrgLicensedProducts,
  useGetOrgLicensedProductsById,
} from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import { SFTSettings } from "./SFTSettings";
import { useGetOrgSftQuery } from "../../../hooks/ReactQueryHooks/useGetOrgSftQuery";
import { Tooltip, Switch } from "@mui/material";
import "./organization.css";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import OrganizationCard from "./OrganizationCard";
import { useSelector } from "react-redux";
import { axios } from "../../../lib/axios";
import { useLocation, useNavigate } from "react-router-dom";
import ListServiceLines from "./ListServiceLines";
import { InfoOutlined } from "@mui/icons-material";
import { use } from "react";
import { set } from "date-fns";
import { getTimeZones } from "@vvo/tzdb";
import Select from "react-select";

export function EditOrganization() {
  const { state } = useLocation();
  const { modalShow, userRoles } = state;
  const navigate = useNavigate();

  const [btnLoading, setBtnLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [file, setFile] = useState();
  const [waitingRoomTimings, setWaitingRoomTimings] = useState(operationTiming);
  const [waitingRoomTimingsError, setWaitingRoomTimingsError] = useState(false);
  const [imageError, setImageError] = useState("");
  const [rpmSwitch, setRpmSwitch] = useState(false);
  const [virtualCareSwitch, setVirtualCareSwitch] = useState(false);
  const [callCenterSwitch, setCallCenterSwitch] = useState(false);
  const [waitingRoomSwitch, setWaitingRoomSwitch] = useState(false);
  const [ctiSwitch, setCtiSwitch] = useState(false);
  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({});
  const [selectedTab, setSelectedTab] = useState(state?.selectedTab || "Details");
  const [delivertoIndividualSwitch, setDelivertoIndividualSwitch] = useState(
    modalShow?.sft?.individualDelivery
  );
  const [delivertoLocationSwitch, setDelivertoLocationSwitch] = useState(
    modalShow?.sft?.locationDelivery
  );
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const userPermissions = useSelector(
    (state) => state?.auth?.user?.permissions
  );
  const { data: orgSftQuery } = useGetOrgSftQuery({});
  const { getConfirmation } = useConfirmDialog();
  const isMobile = useMedia("(max-width: 768px)");
  const dispatch = useDispatch();
  const modalId = modalShow?.id;
  const isAdmin = userRoles?.includes("Super-Admin");

  const [settingsData, setSettingsData] = useState({});
  const [enforceHCNSwitch, setEnforceHCNSwitch] = useState(false);
  const [enforceEmailSwitch, setEnforceEmailSwitch] = useState(false);
  const [enforcePhoneNumberSwitch, setEnforcePhoneNumberSwitch] = useState(false);
  const [enforceAddressSwitch, setEnforceAddressSwitch] = useState(false);
  const [enforceCountrySwitch, setEnforceCountrySwitch] = useState(false);
  const [enforceProvinceSwitch, setEnforceProvinceSwitch] = useState(false);
  const [enforceCitySwitch, setEnforceCitySwitch] = useState(false);
  const [enforcePostalCodeSwitch, setEnforcePostalCodeSwitch] = useState(false);
  const [enforceDOBSwitch, setEnforceDOBSwitch] = useState(false);
  const [enforceGenderSwitch, setEnforceGenderSwitch] = useState(false);
  const [enforceFirstNameSwitch, setEnforceFirstNameSwitch] = useState(false);
  const [enforceLastNameSwitch, setEnforceLastNameSwitch] = useState(false);

  const [enforcePractitionerDOB, setEnforcePractitionerDOB] = useState(false);
  const [enforcePractitionerGender, setEnforcePractitionerGender] = useState(false);
  const [enforcePractitionerAddress, setEnforcePractitionerAddress] = useState(false);
  const [enforcePractitionerCountry, setEnforcePractitionerCountry] = useState(false);
  const [enforcePractitionerProvince, setEnforcePractitionerProvince] = useState(false);
  const [enforcePractitionerCity, setEnforcePractitionerCity] = useState(false);
  const [enforcePractitionerPostal, setEnforcePractitionerPostal] = useState(false);
  const [ecrEnabled, setEcrEnabled] = useState(false);
  const [orgSettings, setOrgSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allowPatientCreationWithAIEnabled, setAllowPatientCreationWithAIEnabled] = useState(false);

  const timeZoneOptions = useMemo(() => {
    const zones = getTimeZones({ includeUtc: true });

    return zones.map((tz) => {
      const now = new Date();

      const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: tz.name,
        timeZoneName: "shortOffset",
      }).formatToParts(now);

      const offset = parts.find((p) => p.type === "timeZoneName")?.value || "";

      const abbrevParts = new Intl.DateTimeFormat("en-US", {
        timeZone: tz.name,
        timeZoneName: "short",
      }).formatToParts(now);

      const abbrev =
        abbrevParts.find((p) => p.type === "timeZoneName")?.value || "";

      const [region = "UTC", city = ""] = (tz.name || "").split("/");
      const formattedRegion = region.replace(/_/g, " ");
      const formattedCity = city.replace(/_/g, " ");
      const countryName = tz.countryName || formattedRegion;

      const label = `${offset} ${countryName}${
        formattedCity ? ` - ${formattedCity}` : ` - ${formattedRegion}`
      }${abbrev ? ` (${abbrev})` : ""}`;

      return {
        value: tz.name,
        label,
        abbrev,
        altName: tz.alternativeName,
      };
    });
  }, []);

  const buildDefaultWRSchedule = (operationTiming) => {
    let defaults = {};
    
    if(Array.isArray(operationTiming)) {
      operationTiming?.forEach(item => {
          defaults[item.weekDay] = {
            startTime: moment(item.startTime),
            endTime: moment(item.endTime)
          }
        })
      return defaults;
    }
    else if(operationTiming) {
      Object.keys(operationTiming).forEach(key => {
        let item = operationTiming[key]
        defaults[key] = {
          startTime: moment(item.startTime),
          endTime: moment(item.endTime),
        }
      })
    }
    return defaults
  }

  const onSuccess = (data) => {
    if (data?.length === 0) {
      setRpmSwitch(rpmSwitch);
      setVirtualCareSwitch(virtualCareSwitch);
      setCallCenterSwitch(callCenterSwitch);
      // setWaitingRoomSwitch(waitingRoomSwitch);
    } else {
      setRpmSwitch(data?.licensedProduct.RPM);
      setVirtualCareSwitch(data.licensedProduct.virtualCare);
      setCallCenterSwitch(data.licensedProduct.callCenter);
      // setWaitingRoomSwitch(data.licensedProduct.waitingRoom);
    }
  };
  const { isLoading, refetch, isFetching } = useDiscoverIdQuery({
    modalId,
    onSuccess,
  });
  const { data: orgLicensedProductsById } = useGetOrgLicensedProductsById({
    orgId: modalShow?.id,
  });
  useEffect(() => {
    if (modalShow) {
      setCtiSwitch(modalShow?.ctiSettings?.enabled || false);
      setWaitingRoomSwitch(modalShow?.isWaitingRoom || false);
    }
  }, []);

  useEffect(() => {
      setLoading(true);
      getOrganizationSettings(modalShow?.id).then((res) => {
        if (res?.status) {
          const p = res.data.patient || {};
          setEnforceHCNSwitch(!!p.hcn);
          setEnforceEmailSwitch(!!p.email);
          setEnforcePhoneNumberSwitch(!!p.phone);
          setEnforceCountrySwitch(!!p.country);
          setEnforceProvinceSwitch(!!p.province);
          setEnforceCitySwitch(!!p.city);
          setEnforceFirstNameSwitch(!!p.firstName);
          setEnforceLastNameSwitch(!!p.lastName);
          setEnforceGenderSwitch(!!p.gender);
          setEnforceDOBSwitch(!!p.dob);
          setEnforcePostalCodeSwitch(!!p.postalCode);
          setEnforceAddressSwitch(!!p.address);

          const pract = res?.data?.practitioner || {};
          setEnforcePractitionerDOB(!!pract.dob);
          setEnforcePractitionerGender(!!pract.gender);
          setEnforcePractitionerAddress(!!pract.address);
          setEnforcePractitionerCountry(!!pract.country);
          setEnforcePractitionerProvince(!!pract.province)
          setEnforcePractitionerCity(!!pract.city);
          setEnforcePractitionerPostal(!!pract.postalCode)
          setEcrEnabled(!!res?.data?.ecrEnabled);
          setAllowPatientCreationWithAIEnabled(!!res?.data?.allowPatientCreationWithAI)
          setOrgSettings(res?.data)
        }
      }).catch((res) => {
        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
      }).finally(() => {
        setLoading(false);
      });
  }, [modalShow?.id]);

  const formik = useFormik({
    ...FormikObj,
    validationSchema: () => getValidationSchema(selectedTab),
    onSubmit: async (values) => {
      values.name = values.name?.trim();
      values.description = values.description?.trim();
      values.address = values.address?.trim();
      values.city = values.city?.trim();
      values.country = values.country?.trim();
      values.region = values.region?.trim();
      values.postalCode = values.postalCode?.trim();
      values.phone_number = values.phone_number?.trim();
      values.email = values.email?.trim();
      values.privacyStatement = values.privacyStatement?.trim();
      values.supportStatement = values.supportStatement?.trim();
        
      await saveOrganization(values);
      if(!virtualCareSwitch) {
        formik.setFieldValue("satisfactionSurvey",false);
        formik.setFieldValue("patientApptAutoAcceptance", false);
        formik.setFieldValue("practitionerApptAutoAcceptance", false);
        formik.setFieldValue("appointment_cancel_time",1)
      }
      if(!waitingRoomSwitch) {
        formik.setFieldValue("isWaitingRoom",false)
        formik.setFieldValue("hoursOfOperation", false);
        const defaultOperationTiming = buildDefaultWRSchedule(modalShow?.operationTiming);
        setWaitingRoomTimings(defaultOperationTiming);
      }
    },
  });

  useEffect(() => {
    if (orgSettings?.encounterReportPrivacyStatement) {
      formik.setFieldValue("encounterReportPrivacyStatement", orgSettings?.encounterReportPrivacyStatement)
    }

    if (orgSettings?.faxCoverPrivacyStatement) {
      formik.setFieldValue("faxCoverPrivacyStatement", orgSettings?.faxCoverPrivacyStatement)
    }

    if (orgSettings?.ecrIdentifier) {
      formik.setFieldValue("ecrIdentifier", orgSettings?.ecrIdentifier)
    }

  }, [orgSettings])

  const saveOrganization = async (values) => {
        // disable settings for VV if not product not available
        if(!virtualCareSwitch) { 
          values.satisfactionSurvey = false;
          values.patientApptAutoAcceptance = false;
          values.practitionerApptAutoAcceptance = false;
          values.appointment_cancel_time = 1;
          formik.setFieldValue("satisfactionSurvey",false);
          formik.setFieldValue("patientApptAutoAcceptance", false);
          formik.setFieldValue("practitionerApptAutoAcceptance", false);
          formik.setFieldValue("appointment_cancel_time",1)
        }
        if(!waitingRoomSwitch) {
          values.isWaitingRoom = false;
          values.hoursOfOperation = false;
          formik.setFieldValue("isWaitingRoom",false)
          formik.setFieldValue("hoursOfOperation", false);
          const defaultOperationTiming = buildDefaultWRSchedule(modalShow?.operationTiming);
          setWaitingRoomTimings(defaultOperationTiming);
        }
        // disable settings for Contact Center if not product not available
        if (!callCenterSwitch) {
          values.initialAssessmentQuestion = false;
          values.isCtiEnabled = false;
          values.dni = [""]
        }

        const isHoursOfOperationFalse =
          !!values.isWaitingRoom && !!!values.hoursOfOperation;
        let hasValues = Object.values(waitingRoomTimings).some(
          (value) => value?.startTime || value?.endTime
        );
        if (isHoursOfOperationFalse && !hasValues) {
          setWaitingRoomTimingsError(true);
        } else {
          setWaitingRoomTimingsError(false);
          setBtnLoading(true);
          let base64OrgLogo = "";
          if (values?.orgLogoURL) {
            base64OrgLogo = await handleFileUpload(values?.orgLogoURL);
          }
          const fileExtension = values?.orgLogoURL?.type?.split("/")[1];
          const base64OrgLogo1 = {
            data: base64OrgLogo,
            extension: fileExtension, // Add the file extension to the object
          };
          const deviceUnit = getDeviceUnit(values);
          values.phone_number = createContactNumber(values);
          if (values.typeOfDeviceUnitType === "group")
            deviceUnit["groupName"] = values.deviceUnitType;

          let sft = values.sftEnabled
            ? {
              enabled: values.sftEnabled,
              individualDelivery: delivertoIndividualSwitch,
              locationDelivery: delivertoLocationSwitch,
              expirationDays: values.expirationDays,
              privacyStatement: values.privacyStatement,
              supportStatement: values.supportStatement,
            }
            : {
              enabled: values.sftEnabled,
              // "privacyStatement": values.privacyStatement,
              // "supportStatement": values.supportStatement
            };

          let appointmentAutoAcceptance = {
            patientInitiated: values?.patientApptAutoAcceptance, //(via the Mobile App)
            practitionerInitiated: values?.practitionerApptAutoAcceptance, //(via the Web UI)
          };

          let mfaSettings = {
            enabled: values?.mfaEnabled,
          };

          let triageSettings = {
            initialAssessmentQuestion: values?.initialAssessmentQuestion
          }

          if (values?.dni?.length > 0) {
            values.dni = values.dni?.map((dni) => dni.replace(/\D/g, ""));
          }

          if (values?.inboundFaxNumber) {
            values.inboundFaxNumber = values.inboundFaxNumber.replace(/\D/g, "");
          }

          editOrganization(
            { ...values, id: modalShow?.id },
            modalShow?.partOfRefId === "000000"
              ? modalShow?.name
              : modalShow.partOf.display,
            modalShow.partOfRefId,
            deviceUnit,
            values?.orgLogoURL ? base64OrgLogo1 : undefined,
            isHoursOfOperationFalse
              ? transformTimingData(waitingRoomTimings)
              : null,
            sft,
            appointmentAutoAcceptance,
            mfaSettings,
            triageSettings
          )
            .then((res) => {
              if (res.status === true) {
                const requestBody = {
                  licensedProduct: {
                    RPM: rpmSwitch,
                    virtualCare: virtualCareSwitch,
                    callCenter: callCenterSwitch,
                  },
                };
                if (userRoles?.includes("Super-Admin")) {
                  editDiscover(modalId, requestBody)
                    .then((res) => {
                      // navigate("/app/manage-organization");
                      // success(res.message);
                    })
                    .catch((res) => {
                      if (res.response.status === 404) {
                        const requestBody = {
                          licensedProduct: {
                            RPM: rpmSwitch,
                            virtualCare: virtualCareSwitch,
                            callCenter: callCenterSwitch,
                          },
                          orgId: modalId,
                        };
                        createDiscover(requestBody)
                          .then((res) => {
                            // navigate("/app/manage-organization");
                            // success(res.message);
                          })
                          .catch((res) =>
                            failed(
                              res?.response?.data?.message ||
                              res?.response?.data?.error ||
                              res.message
                            )
                          )
                          .finally(() => setBtnLoading(false));
                      } else {
                        failed(
                          res?.response?.data?.message ||
                          res?.response?.data?.error ||
                          res.message
                        );
                      }
                    })
                    .finally(() => setBtnLoading(false));

                }
                const settingsPayload = {
                    "patient": {
                      "hcn": enforceHCNSwitch,
                      "email": enforceEmailSwitch,
                      "phone": enforcePhoneNumberSwitch,
                      "address": enforceAddressSwitch,
                      "country": enforceCountrySwitch,
                      "province": enforceProvinceSwitch,
                      "city": enforceCitySwitch,
                      "postalCode": enforcePostalCodeSwitch,
                      "dob": enforceDOBSwitch,
                      "gender": enforceGenderSwitch,
                      "firstName": enforceFirstNameSwitch,
                      "lastName": enforceLastNameSwitch
                    },
                    "practitioner": {
                      "dob": enforcePractitionerDOB,
                      "gender": enforcePractitionerGender,
                      "address": enforcePractitionerAddress,
                      "country": enforcePractitionerCountry,
                      "province": enforcePractitionerProvince,
                      "city": enforcePractitionerCity,
                      "postalCode": enforcePractitionerPostal
                    },
                    ecrEnabled: ecrEnabled,
                    ecrIdentifier: values?.ecrIdentifier,
                    encounterReportPrivacyStatement: values?.encounterReportPrivacyStatement,
                    faxCoverPrivacyStatement: values?.faxCoverPrivacyStatement,
                    allowPatientCreationWithAI: allowPatientCreationWithAIEnabled
                  };
                  if(selectedTab =="Service Lines" || selectedTab === "Privacy Statements" || selectedTab === "Settings" || selectedTab === "Client Registry"){
                    setBtnLoading(true);
                    //Saving organization settings only when clicking Save on the Settings tab, then moving to the next tab — Service Lines.
                    editOrganizationSettings(modalId, {
                      settings: settingsPayload
                    }).then((res) => {
                      success(res.message);
                    }).catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message)).finally(() => setBtnLoading(false));
                  }
                success(res.message);
                dispatch(
                  updateOrganizationLogo(res?.data?.organizationLogo?.base64)
                );
                dispatch(updateOrganizationName(res?.data?.name));
              } else {
                failed(res.error);
              }
            })
            .catch((res) => {
              failed(
                res?.response?.data?.message ||
                res?.response?.data?.error ||
                res.message
              );
            })
            .finally(() => setBtnLoading(false));
        }
    }

  useEffect(() => {
    if (selectedTab === "Details") {
      formik.validateForm().then((errors) => {
        let imageLogoError = errors?.orgLogoURL;
        if (Object.keys(errors).length === 0 && !imageLogoError) {
          setImageError("");
        } else {
          if (imageLogoError) setImageError(imageLogoError);
        }
      });
    }
  }, [formik?.values?.orgLogoURL]);

  useEffect(() => {
    if (formik.values.hoursOfOperation) {
      setWaitingRoomTimingsError(false);
    }
  }, [formik?.values?.hoursOfOperation]);

  useEffect(() => {
    if (
      waitingRoomTimings &&
      Object.values(waitingRoomTimings).some(
        (value) => value?.startTime || value?.endTime
      )
    ) {
      setWaitingRoomTimingsError(false);
    }
  }, [waitingRoomTimings]);

  useEffect(() => {
    fetchOrgnization(modalShow?.id);
  }, [adminOrgs?.[0]?.id]);

  const fetchOrgnization = async (orgId) => {
    let response;
    try {
      response = await axios.get(`organization/${orgId}`);
      if (response?.status) {
        setFile(response?.data?.organizationLogo?.base64);
      } else {
        failed(response?.error);
      }
    } catch (error) {
      failed(response?.error);
    }
  };

  useEffect(() => {
    if (modalShow?.id) {
      formik.setFieldValue("name", modalShow?.name || "");
      formik.setFieldValue("address", modalShow?.address?.[0]?.line?.[0] || "");
      formik.setFieldValue(
        "postalCode",
        modalShow?.address?.[0]?.postalCode || ""
      );
      setInputValue(modalShow?.address?.[0]?.postalCode || "");
      formik.setFieldValue("country", modalShow?.address?.[0]?.country || "");
      formik.setFieldValue("city", modalShow?.address?.[0]?.city || "");
      formik.setFieldValue("state", modalShow?.address?.[0]?.state || "");
      formik.setFieldValue(
        "phone_number",
        splitContactNumber(modalShow?.telecom[0]?.value || "")?.phone_number ||
        ""
      );
      formik.setFieldValue(
        "ext",
        splitContactNumber(modalShow?.telecom[0]?.value || "").ext
      );
      formik.setFieldValue("email", modalShow?.telecom?.[1]?.value || "");
      formik.setFieldValue("id", modalShow?.id || "");
      formik.setFieldValue("parent", modalShow?.partOf?.display || "");
      formik.setFieldValue("description", modalShow?.description || "");
      formik.setFieldValue("timeZone", modalShow?.timeZone || null);
      formik.setFieldValue("dni", modalShow?.ctiSettings?.dni || [""]);
      formik.setFieldValue(
        "isCtiEnabled",
        modalShow?.ctiSettings?.enabled || false
      );
      formik.setFieldValue("inboundFaxNumber", modalShow?.faxSettings?.inboundFaxNumber || "");
      formik.setFieldValue("initialAssessmentQuestion", modalShow?.triageSettings?.initialAssessmentQuestion ?? true)

      /**
       * PLEASE NOTE: This if/else condition will become redundant when all organizational
       * data is in the proper format.  This is purely for backwards compatibility as originally
       * the cancellation time was stored in hours and as a JSON object. In the future it will now be minutes and
       * an integer value.
       */
      let cutoffMinutes = 1;
      let cutoffSettings = modalShow?.appointmentCancellationTime;
      if (
        typeof cutoffSettings == "object" &&
        cutoffSettings?.unit &&
        !isNaN(cutoffSettings?.unit)
      ) {
        cutoffMinutes = parseInt(cutoffSettings.unit, 10) * 60;
      } else if (!isNaN(cutoffSettings)) {
        cutoffMinutes = parseInt(cutoffSettings, 10);
      }

      formik.setFieldValue("appointment_cancel_time", cutoffMinutes);
      formik.setFieldValue("isWaitingRoom", modalShow?.isWaitingRoom || false)
      formik.setFieldValue(
        "typeOfDeviceUnitType",
        modalShow?.deviceUnit?.type || ""
      );
      formik.setFieldValue(
        "deviceUnitType",
        modalShow?.deviceUnit?.groupName || ""
      );
      formik.setFieldValue("oxygen", modalShow?.deviceUnit?.oxygen?.oxygen);
      formik.setFieldValue(
        "heart_rate",
        modalShow?.deviceUnit?.heart_rate?.heartRate
      );
      formik.setFieldValue(
        "weight",
        modalShow?.deviceUnit?.weight?.weight || ""
      );
      formik.setFieldValue(
        "temperature",
        modalShow?.deviceUnit?.temperature?.temperature || ""
      );
      formik.setFieldValue(
        "blood_pressure",
        modalShow?.deviceUnit?.blood_pressure?.systolic || ""
      );
      formik.setFieldValue(
        "blood_glucose",
        modalShow?.deviceUnit?.blood_glucose?.glucose || ""
      );
      setCountry(modalShow?.address?.[0]?.country);
      setRegion(modalShow?.address?.[0]?.state);
      // setFile(modalShow?.organizationLogo?.url)
      formik.setFieldValue("isWaitingRoom", !!modalShow?.isWaitingRoom);
      formik.setFieldValue(
        "satisfactionSurvey",
        !!modalShow?.surveySetting?.satisfactionSurvey
      );
      formik.setFieldValue("hoursOfOperation", !!modalShow?.hoursOfOperation);
      formik.setFieldValue("survey", modalShow?.surveySetting?.survey);

      formik.setFieldValue(
        "expirationDays",
        modalShow?.sft?.expirationDays / (60 * 60 * 24) || 1
      );
      formik.setFieldValue(
        "privacyStatement",
        modalShow?.sft?.privacyStatement || ""
      );
      formik.setFieldValue(
        "supportStatement",
        modalShow?.sft?.supportStatement || ""
      );
      formik.setFieldValue("sftEnabled", modalShow?.sft?.enabled || "");
      formik.setFieldValue("active", modalShow?.active ?? true);
      formik.setFieldValue(
        "patientApptAutoAcceptance",
        modalShow?.appointmentAutoAcceptance?.patientInitiated || ""
      );
      formik.setFieldValue(
        "practitionerApptAutoAcceptance",
        modalShow?.appointmentAutoAcceptance?.practitionerInitiated || ""
      );
      formik.setFieldValue("mfaEnabled", modalShow?.mfaSettings?.enabled);

      if (!!modalShow?.isWaitingRoom && !!!modalShow?.hoursOfOperation) {
        const defaultOperationTiming = buildDefaultWRSchedule(modalShow?.operationTiming);
        // modalShow?.operationTiming?.forEach(
        //   ({ weekDay, startTime, endTime }) =>
        //   (defaultOperationTiming[weekDay] = {
        //     startTime: moment(startTime),
        //     endTime: moment(endTime),
        //   })
        // );
        setWaitingRoomTimings(defaultOperationTiming);
      }
    } else {
      setCountry("");
      setRegion("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalShow]);

  const handleUnitOfDeviceChange = (key, value) => {
    formik.setFieldValue(key, value);
  };

  //validation if Country is selected but region not selected
  const handleCountryChange = (newCountry) => {
    setCountry(newCountry);
    if (newCountry !== formik.values.country) {
      formik.setFieldValue("state", ""); // Reset Formik state only if the country is changing
      formik.setFieldValue("postalCode", "");
      formik.setFieldValue("city", "");
      setRegion(""); // Reset component state only if the country is changing
      setInputValue("");
    }
  };

  const handleTimeChange = (day, value, key) => {
    key === "startTime"
      ? setWaitingRoomTimings({
        ...waitingRoomTimings,
        [day]: { startTime: value, endTime: null },
      })
      : setWaitingRoomTimings({
        ...waitingRoomTimings,
        [day]: { ...waitingRoomTimings[day], [key]: value },
      });
  };

  if (!formik.values?.id) {
    return null;
  }

  const handlePostalCodeChange = (e) => {
    const { value } = e.target;
    // Remove spaces and non-alphanumeric characters
    const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
    // Add a space after every 3 letters
    const spacedValue = formattedValue.replace(
      /^([A-Za-z0-9]{3})([A-Za-z0-9]+)/,
      "$1 $2"
    );
    // Set the formatted value in the state or formik
    setInputValue(spacedValue);
    formik?.setFieldValue("postalCode", spacedValue);
  };

  const handleCTISwitchChange = () => {
    setCtiSwitch((prev) => {
      const newValue = !prev;
      if (!newValue) {
        formik.setFieldValue("dni", [""]); // Reset dni when toggled off
      }
      if (newValue) {
        formik.setFieldValue("isCtiEnabled", true);
      } else {
        formik.setFieldValue("isCtiEnabled", false);
      }
      return newValue;
    });
  };

  const handleSwitchChange = (setter) => {
    setter((prevValue) => !prevValue);
  };
  const handleSFTToggle = (event) => {
    formik?.setFieldValue("sftEnabled", event.target.checked);
  };
  const handleIAQToggle = (event) => {
    formik?.setFieldValue("initialAssessmentQuestion", event.target.checked);
  };

  const handleMFAToggle = (event) => {
    formik.setFieldValue("mfaEnabled", event.target.checked);
  };
  const handleOrgActiveToggle = (event) => {
    formik?.setFieldValue("active", event.target.checked);
  };

  const handleApptAcceptance = (event, type) => {
    if (type === "patientApptAutoAcceptance") {
      formik?.setFieldValue("patientApptAutoAcceptance", event.target.checked);
    } else if (type === "practitionerApptAutoAcceptance") {
      formik?.setFieldValue(
        "practitionerApptAutoAcceptance",
        event.target.checked
      );
    }
  };
  //   let margLeft =  formik.values.sftEnabled ? { marginLeft: '1px', marginRight: '-655px' } :  { marginLeft: '1px', marginRight: '-810px' } ;


  const isPractitioner = userRoles?.includes("Practitioner");
  const isRPMEnabled = isPractitioner && orgLicensedProductsById?.RPM === true;
  const isVirtualCareEnabled =
    isPractitioner && orgLicensedProductsById?.virtualCare === true;
  const isCallCenterEnabled =
    isPractitioner && orgLicensedProductsById?.callCenter === true;
    
  /* Tabs */
  let tabTitles = [];
  if (isAdmin) {
    tabTitles = ["Details", "Products", "Settings", "Service Lines", "Client Registry"];
    if (virtualCareSwitch) {
      tabTitles.push("Virtual Visit");
    }
    if(waitingRoomSwitch) {
      tabTitles.push("Waiting Room");
    }
    if(virtualCareSwitch || callCenterSwitch) 
      tabTitles.push("File Transfer");

    if (rpmSwitch) {
      tabTitles.push("RPM");
    }
    if (callCenterSwitch) {
      tabTitles.push("Contact Center")
    }
    if (ctiSwitch && callCenterSwitch) {
      tabTitles.push("Telephony");
    }
  } else if (isPractitioner) {
    // Details
    if (!tabTitles.includes("Details")) tabTitles.push("Details");
    tabTitles.push("Privacy Statements")
    tabTitles.push("Service Lines");
    if (userPermissions?.includes("Manage Organization")) {
      tabTitles.push("MFA");
    }
    // Virtual Visit
    if (isVirtualCareEnabled && !tabTitles.includes("Virtual Visit"))
      tabTitles.push("Virtual Visit");
    // RPM
    if (isRPMEnabled && !tabTitles.includes("RPM")) {
      if (!tabTitles.includes("Virtual Visit")) {
        // If "Virtual Visit" is not present, add "RPM" after "Details"
        const index = tabTitles.indexOf("Details") + 1;
        tabTitles.splice(index, 0, "RPM");
      } else {
        // If "Virtual Visit" is present, add "RPM" after it
        const index = tabTitles.indexOf("Virtual Visit") + 1;
        tabTitles.splice(index, 0, "RPM");
      }
    }
    // File Transfer
    if (!tabTitles.includes("File Transfer")) {
      if (tabTitles.includes("RPM")) {
        // If "RPM" is present, then add it after "RPM"
        const index = tabTitles.indexOf("RPM") + 1;
        tabTitles.splice(index, 0, "File Transfer");
      } else {
        if (tabTitles.includes("Virtual Visit")) {
          // If "Virtual Visit" is present, add "File Transfer" after "Virtual Visit"
          const index = tabTitles.indexOf("Virtual Visit") + 1;
          tabTitles.splice(index, 0, "File Transfer");
        } else {
          // If "Virtual Visit" is also not present, add "File Transfer" after "Details"
          const index = tabTitles.indexOf("Details") + 1;
          tabTitles.splice(index, 0, "File Transfer");
        }
      }
    }

    if (callCenterSwitch) {
      tabTitles.push("Contact Center")
    }

    if (ctiSwitch && callCenterSwitch) {
      tabTitles.push("Telephony");
    }
  }

  const tabs = tabTitles.map((title) => ({
    id: title,
    title: title,
    onClick: () => {
      if (selectedTab === "Virtual Visit") {
        formik.validateForm().then((errors) => {
          let isHoursOfOperationFalse =
            !!formik.values.isWaitingRoom && !!!formik.values.hoursOfOperation;
          let hasValues = Object.values(waitingRoomTimings).some(
            (value) => value?.startTime || value?.endTime
          );
          if (
            Object.keys(errors).length === 0 &&
            !isHoursOfOperationFalse &&
            hasValues
          ) {
            setSelectedTab(title);
            setWaitingRoomTimingsError(false);
          } else {
            if (isHoursOfOperationFalse && !hasValues) {
              setWaitingRoomTimingsError(true);
            } else {
              setWaitingRoomTimingsError(false);
              if (Object.keys(errors).length === 0) {
                setSelectedTab(title);
              }
            }
          }
        });
      } else if (selectedTab === "Details") {
        formik.validateForm().then((errors) => {
          let imageLogoError = errors.orgLogoURL;
          if (Object.keys(errors).length === 0 && !imageLogoError) {
            setSelectedTab(title);
            setImageError("");
          } else {
            if (imageLogoError) setImageError(imageLogoError);
          }
        });
      } else {
        formik.validateForm().then((errors) => {
          if (Object.keys(errors).length === 0) {
            setSelectedTab(title);
          }
        });
      }
    },
    selected: selectedTab === title,
  }));

  /* Previous button */
  const handlePrevious = () => {
    const currentIndex = tabTitles.indexOf(selectedTab);
    const previousTab = tabTitles[currentIndex - 1];
    setSelectedTab(previousTab);
  };

  /* Next button */
  const handleNext = () => {
    if (selectedTab === "Virtual Visit") {
      formik.validateForm().then((errors) => {
        let isHoursOfOperationFalse =
          !!formik.values.isWaitingRoom && !!!formik.values.hoursOfOperation;
        let hasValues = Object.values(waitingRoomTimings).some(
          (value) => value?.startTime || value?.endTime
        );
        if (
          Object.keys(errors).length === 0 &&
          !isHoursOfOperationFalse &&
          hasValues
        ) {
          // const currentIndex = tabTitles.indexOf(selectedTab);
          // const nextTab = tabTitles[currentIndex + 1];
          // setSelectedTab(nextTab);
          setWaitingRoomTimingsError(false);
        } else {
          if (isHoursOfOperationFalse && !hasValues) {
            setWaitingRoomTimingsError(true);
          } else {
            setWaitingRoomTimingsError(false);
            // if (Object.keys(errors).length === 0) {
            //   const currentIndex = tabTitles.indexOf(selectedTab);
            //   const nextTab = tabTitles[currentIndex + 1];
            //   setSelectedTab(nextTab);
            // }
          }
        }
      });
    } else if (selectedTab === "Details") {
      formik.validateForm().then((errors) => {
        let imageLogoError = errors.orgLogoURL;
        if (Object.keys(errors).length === 0 && !imageLogoError) {
          // const currentIndex = tabTitles.indexOf(selectedTab);
          // const nextTab = tabTitles[currentIndex + 1];
          // setSelectedTab(nextTab);
          setImageError("");
        } else {
          if (imageLogoError) setImageError(imageLogoError);
        }
      });
    } else {
      formik.validateForm().then((errors) => {
        // if (Object.keys(errors).length === 0) {
        //   const currentIndex = tabTitles.indexOf(selectedTab);
        //   const nextTab = tabTitles[currentIndex + 1];
        //   setSelectedTab(nextTab);
        // }
      });
    }
  };

  const handleExt = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  const handleAddDNIRow = () => {
    let existingValues = formik?.values?.dni;
    let newValues = [...existingValues, ""];
    formik.setFieldValue("dni", newValues);
  };

  const handleRemoveDNI = (index) => {
    const existingValues = formik?.values?.dni || [];
    const newValues = existingValues.filter((_, i) => i !== index);
    formik.setFieldValue("dni", newValues);
  };
  const handleCancelClick = () => {
    navigate("/app/manage-organization");
  };
  const anyFeatureEnabled =
    virtualCareSwitch || callCenterSwitch || rpmSwitch || ctiSwitch;
  const isLastTab = selectedTab === tabTitles[tabTitles.length - 1];

  return (
    <section className="common-listing">
      <form
        className="common-form border-fields"
        onSubmit={formik.handleSubmit}
      >
        <Row>
          {tabs.map((tab) => (
            <Col key={tab.id} className="mb-3 mb-lg-0" onClick={tab.onClick}>
              <OrganizationCard title={tab.title} selected={tab.selected} />
            </Col>
          ))}
        </Row>
        <br />
        {formik.values?.name ? <h4 style={{color: 'rgb(0, 93, 168)', marginLeft: 0, paddingBottom: 20, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{ formik.values["name"] } </h4> : null }
        {/* Details start */}
        <div style={{ display: selectedTab === "Details" ? "block" : "none" }}>
          <Row>
            <Col>
              {formik.values.parent === "Fonemed" ? null : (
                <TextInput
                  readOnly={true}
                  keyField={"parent"}
                  label={PARENT_ORGANIZATION}
                  required={false}
                  formik={formik}
                />
              )}
            </Col>
            <Col>
              <TextInput
                keyField={"name"}
                label={NAME}
                formik={formik}
                placeholder={NAME}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextArea
                keyField={"description"}
                required={false}
                label={DESCRIPTION}
                formik={formik}
                placeholder={DESCRIPTION}
              />
            </Col>
          </Row>
          <Row>
            <Col md={8} lg={4}>
              <div className="field-wrap">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "4px",
                  }}
                >
                  <label>Preferred Time Zone (Optional)</label>
                  <Tooltip title="If not specified, the organization's time zone will default to UTC.">
                    <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                  </Tooltip>
                </div>
                <Select
                  className="search-select"
                  classNamePrefix="select"
                  isClearable
                  options={timeZoneOptions}
                  filterOption={(option, inputValue) =>
                    option.label
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                  isDisabled={!isAdmin}
                  value={
                    timeZoneOptions.find(
                      (opt) =>
                        opt.value === formik.values.timeZone?.value ||
                        opt.value === formik.values.timeZone?.name
                    ) || null
                  }
                  onChange={(val) => {
                    formik.setFieldValue("timeZone", val);
                  }}
                  placeholder="Select time zone"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                keyField={"address"}
                label={ADDRESS}
                formik={formik}
                placeholder={ADDRESS}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CountrySelect
                country={country}
                setCountry={handleCountryChange}
                keyField={"country"}
                label={COUNTRY}
                formik={formik}
              />
            </Col>
            <Col>
              <RegionSelect
                country={country}
                setRegion={setRegion}
                region={region}
                keyField={"state"}
                defaultOptionLabel={
                  formik?.values?.country === "US"
                    ? "Select State"
                    : "Select Province"
                }
                label={formik?.values?.country === "US" ? "State" : "Province"}
                required
                formik={formik}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                keyField={"city"}
                label={CITY}
                formik={formik}
                placeholder={CITY}
              />
            </Col>

            <Col>
              {formik?.values?.country === "US" ? (
                <TextInput
                  keyField={"postalCode"}
                  label={
                    formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
                  }
                  formik={formik}
                  placeholder={
                    formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
                  }
                  // max length for both zip code and postal code(plus space)
                  maxLength={formik?.values?.country === "US" ? "5" : "7"}
                />
              ) : (
                <TextInput
                  onChange={handlePostalCodeChange}
                  value={inputValue}
                  keyField={"postalCode"}
                  label={
                    formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
                  }
                  formik={formik}
                  placeholder={
                    formik?.values?.country === "US" ? ZIP_CODE : POSTAL_CODE
                  }
                  // max length for both zip code and postal code(plus space)
                  maxLength={formik?.values?.country === "US" ? "5" : "7"}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                type="phone"
                keyField={"phone_number"}
                label={PHONE_NUMBER}
                formik={formik}
                placeholder={PHONE_NUMBER}
              />
            </Col>
            <Col>
              <TextInput
                keyField={"ext"}
                label={"Ext."}
                type="text"
                maxlength="4"
                formik={formik}
                placeholder={"Ext."}
                required={false}
                onKeyPress={handleExt}
                autocomplete="off"
              />
            </Col>
            <Col>
              <TextInput
                keyField={"email"}
                label={EMAIL_ADDRESS}
                formik={formik}
                placeholder={EMAIL_ADDRESS}
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ maxWidth: "300px" }}>
              <InputFile
                accept="image/jpeg, image/png"
                keyField={"orgLogoURL"}
                label={"Upload Logo"}
                formik={formik}
                placeholder={"Upload Logo"}
                setFile={setFile}
                file={file}
                imageUrl={file}
              />
              <div>
                {imageError ? (
                  <div className="org-img-error">{imageError}</div>
                ) : null}
              </div>
            </Col>
          </Row>
        </div>
        {/* Details End */}

        {/* Client Registry Tab */}
        {
          <div style={{ display: selectedTab === "Client Registry" ? "block" : "none" }}>
            <div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
              <label style={{ fontWeight: "bold", fontSize: "20px" }}>External Client Registry:</label>
              <div style={{ marginTop: "20px", marginLeft: "20px" }}>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                  <label style={{ fontSize: "18px" }}>Enable External Client Registry:</label>
                  <Switch
                    name="ecrEnabled"
                    onChange={() => handleSwitchChange(setEcrEnabled)}
                    checked={ecrEnabled}
                  />
                  <Tooltip title="If enabled, External Client Registry will be enabled for this organization." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                    <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                  </Tooltip>
                </div>
              </div>
            </div>
            <div style={{ marginTop: "5px" }}>
              <Row>
                <Col>
                  <TextInput
                    keyField={"ecrIdentifier"}
                    label={"Client Registry Identifier"}
                    formik={formik}
                    placeholder={"Client Registry Identifier"}
                    tooltip={"A unique identifier for the client registry provider"}
                    hideRequired={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
        }

        {/* MFA tab */}
        <div style={{ display: selectedTab === "MFA" ? "block" : "none" }}>
          <Row>
            <Col>
              <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
                Multi Factor Authentication Settings
              </h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <span>Enable</span>
              <span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
              <Switch
                name="mfaEnabled"
                onChange={handleMFAToggle}
                defaultChecked={modalShow?.mfaSettings?.enabled}
              />
            </Col>
          </Row>
          <hr />

          <Row>
            <Col>
              <p style={{ fontSize: "16px", marginTop: "10px" }}>
                By enabling MFA, add an extra layer of security to users under
                the organization. When enabled, users who do not have MFA
                enabled, will be enforced to setup MFA using Authenticator Apps
                or SMS based Authentication. This helps protect accounts from
                unauthorized access, even if password is compromised. We
                recommend keeping MFA enabled for enhanced security.
              </p>
            </Col>
          </Row>
        </div>

        {/* RPM start */}
        {isAdmin || isRPMEnabled ? (
          <>
            <div style={{ display: selectedTab === "RPM" ? "block" : "none" }}>
              <Row>
                <Col>
                  <SelectFiled
                    keyField={"typeOfDeviceUnitType"}
                    label={DEVICE_UNIT_TYPE}
                    formik={formik}
                    options={typeOfDeviceUnitTypeOptions}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "typeOfDeviceUnitType",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col>
                  {formik.values.typeOfDeviceUnitType === "group" ? (
                    <SelectFiled
                      keyField={"deviceUnitType"}
                      label={TYPE}
                      formik={formik}
                      options={deviceUnitTypeOptions}
                      onChange={(e) =>
                        formik.setFieldValue("deviceUnitType", e.target.value)
                      }
                    />
                  ) : null}
                </Col>
              </Row>
              {formik.values.typeOfDeviceUnitType === "individual" ? (
                <Row>
                  {devicesField?.map((field) => (
                    <Col key={field.formikKey}>
                      <SelectFiled
                        keyField={field.formikKey}
                        label={field.name}
                        formik={formik}
                        options={field.options}
                        onChange={(e) =>
                          handleUnitOfDeviceChange(
                            field.formikKey,
                            e.target.value
                          )
                        }
                      />
                    </Col>
                  ))}
                </Row>
              ) : null}
            </div>
          </>
        ) : null}
        {/* RPM end */}

        {/* Virtual visit start */}
        {isAdmin || isVirtualCareEnabled ? (
          <>
            <div
              style={{
                display: selectedTab === "Virtual Visit" ? "block" : "none",
              }}
            >
              {userRoles?.includes("Super-Admin") ||
                (userRoles?.includes("Practitioner") &&
                  orgLicensedProducts.virtualCare === true) ? (
                <>
                  {/* <GetCareSettings
                    formik={formik}
                    waitingRoomTimings={waitingRoomTimings}
                    waitingRoomTimingsError={waitingRoomTimingsError}
                    isMobile={isMobile}
                    handleTimeChange={handleTimeChange}
                  />
                  <hr /> */}
                  <SurveySettings formik={formik} />
                  <hr />{" "}
                </>
              ) : null}
              {userRoles?.includes("Super-Admin") ||
                userRoles?.includes("Practitioner") ? (
                <>
                  <Row>
                    <Col>
                      <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
                        Appointment Settings
                      </h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Auto Acceptance - Patient Initiated</span>
                      <span style={{ marginRight: "135px" }}>&nbsp;&nbsp;</span>
                      <Switch
                        name="patientApptAutoAcceptance"
                        onChange={(e) =>
                          handleApptAcceptance(e, "patientApptAutoAcceptance")
                        }
                        defaultChecked={
                          modalShow?.appointmentAutoAcceptance?.patientInitiated
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span>Auto Acceptance - Practitioner Initiated</span>
                      <span style={{ marginRight: "100px" }}>&nbsp;&nbsp;</span>
                      <Switch
                        name="practitionerApptAutoAcceptance"
                        onChange={(e) =>
                          handleApptAcceptance(
                            e,
                            "practitionerApptAutoAcceptance"
                          )
                        }
                        defaultChecked={
                          modalShow?.appointmentAutoAcceptance
                            ?.practitionerInitiated
                        }
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <TextInput
                        keyField={"appointment_cancel_time"}
                        label={APPOINTMENT_CANCEL_TIME}
                        formik={formik}
                        placeholder={APPOINTMENT_CANCEL_TIME}
                      />
                    </Col>
                  </Row>
                </>
              ) : null}
            </div>
          </>
        ) : null}
        {/* Virtual visit end */}
        {/* Waiting Room start */}
        {isAdmin || waitingRoomSwitch ? (
          <>
            <div
              style={{
                display: selectedTab === "Waiting Room" ? "block" : "none",
              }}
            >
              {userRoles?.includes("Super-Admin") ||
                (userRoles?.includes("Practitioner")) ? (
                <>
                  <GetCareSettings
                    formik={formik}
                    waitingRoomTimings={waitingRoomTimings}
                    waitingRoomTimingsError={waitingRoomTimingsError}
                    isMobile={isMobile}
                    handleTimeChange={handleTimeChange}
                  />    
              </>
              ) : null}
            </div>
          </>
        ) : null}
        {/* Waiting Room end */}
        {/* File transfer start */}
        <div
          style={{
            display: selectedTab === "File Transfer" ? "block" : "none",
          }}
        >
          <Row>
            <Col>
              <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>SFT Settings</h5>
            </Col>
          </Row>
          <Row>
            {/* <Col style={margLeft}>SFT</Col>
                            <Col >
                            <Switch name="sftEnabled" onChange={handleSFTToggle} defaultChecked={modalShow?.sft?.enabled} />
                            </Col> */}
            <Col>
              <span>SFT</span>
              <span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
              <Switch
                name="sftEnabled"
                onChange={handleSFTToggle}
                defaultChecked={modalShow?.sft?.enabled}
              />
            </Col>
          </Row>
          {formik.values.sftEnabled ? (
            <>
              <SFTSettings
                delivertoIndividualSwitch={delivertoIndividualSwitch}
                delivertoLocationSwitch={delivertoLocationSwitch}
                onDeliverToIndSwitchChange={() =>
                  handleSwitchChange(setDelivertoIndividualSwitch)
                }
                onDeliverToLocSwitchChange={() =>
                  handleSwitchChange(setDelivertoLocationSwitch)
                }
              />

              <Row>
                <Col>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>Expiration Days</span>
                    <span style={{ color: "red" }}>*</span>
                    <span style={{ marginRight: "85px" }}>&nbsp;&nbsp;</span>
                    <Tooltip title="Expiration days must be between 1 to 7">
                      <div className="expiration-days-input">
                        <TextInput
                          keyField={"expirationDays"}
                          formik={formik}
                          required={formik.values.sftEnabled ? true : false}
                        />
                      </div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <TextArea
                    keyField={"privacyStatement"}
                    required={formik.values.sftEnabled ? true : false}
                    label={"Privacy Statement"}
                    formik={formik}
                    placeholder={""}
                  />
                </Col>
                <Col></Col>
              </Row>

              <Row>
                <Col>
                  <TextArea
                    keyField={"supportStatement"}
                    required={formik.values.sftEnabled ? true : false}
                    label={"Technical Support Statement"}
                    formik={formik}
                    placeholder={""}
                  />
                </Col>
                <Col></Col>
              </Row>
            </>
          ) : null}
          <hr />
          {/* This Fax Setting is used to manage the inbound fax number for the organization - It was added as a fix for hardcoded value in the document service for SRFAX */}
          <Row>
            <Col>
              <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>Fax Settings</h5>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: "10px" }}>
              <TextInput
                keyField="inboundFaxNumber"
                label="Inbound Fax Number"
                formik={formik}
                placeholder="Inbound Fax Number"
                tooltip="Enter the SRFax inbound fax number for this organization. The system checks the SRFax inbox every 15 minutes — any fax received on this number will automatically be downloaded and appear in the Documents dashboard under this organization."
                required={false}
                hideRequired={true}
                disabled={!isAdmin && !userPermissions?.includes("Manage Organization")}
              />
            </Col>
          </Row>
        </div>
        {/* File transfer End */}

        {/* Products start */}
        {userRoles?.includes("Super-Admin") && (
          <div
            style={{ display: selectedTab === "Products" ? "block" : "none" }}
          >
            {userRoles?.includes("Super-Admin") ? (
              <>
                <ProductFeatures
                  rpmSwitch={rpmSwitch}
                  virtualCareSwitch={virtualCareSwitch}
                  waitingRoomSwitch={waitingRoomSwitch}
                  callCenterSwitch={callCenterSwitch}
                  onRpmSwitchChange={() => handleSwitchChange(setRpmSwitch)}
                  onVirtualCareSwitchChange={() =>
                    handleSwitchChange(setVirtualCareSwitch)
                  }
                  onWaitingRoomSwitchChange={() =>
                    handleSwitchChange(setWaitingRoomSwitch)
                  }
                  onCallCenterSwitchChange={() =>
                    handleSwitchChange(setCallCenterSwitch)
                  }
                />
                <hr />{" "}
              </>
            ) : null}

            {/* Organization Active/Inactive */}
            {userRoles?.includes("Super-Admin") ? (
              <>
                <Row>
                  <Col>
                    <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
                      {" "}
                      Organization Active/Inactive Settings
                    </h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>Active or Inactive </span>
                    <span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
                    <Switch
                      name="active"
                      onChange={handleOrgActiveToggle}
                      defaultChecked={modalShow?.active}
                    />
                  </Col>
                </Row>
                <hr />{" "}
              </>
            ) : null}
            {!formik.values.active ? (
              <>
                <div class="alert alert-warning" role="alert">
                  Attention: Disabling organization will suspend access for all
                  users for this organization, including practitioners, until it
                  is enabled again.
                </div>
              </>
            ) : null}

            {userRoles?.includes("Super-Admin") && callCenterSwitch ? (
              <>
                <Row>
                  <Col>
                    <h5 style={{ color: "rgba(18, 31, 72, 1)" }}>
                      {" "}
                      Computer Telephony Integration (CTI)
                    </h5>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <span>Active or Inactive </span>
                    <span style={{ marginRight: "175px" }}>&nbsp;&nbsp;</span>
                    <Switch
                      name="active"
                      onChange={handleCTISwitchChange}
                      defaultChecked={ctiSwitch}
                    />
                  </Col>
                </Row>
              </>
            ) : null}
          </div>
        )}
        {/* Products End */}

        {/* Triage Settings */}
        <div
          style={{
            display: selectedTab === "Contact Center" ? "block" : "none",
          }}
        >
          <Row>
            <Col>
              <h5 style={{ color: "rgba(18, 31, 72, 1)", marginTop: "20px" }}>Triage Settings (Protocol)</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ marginLeft: '10px', marginRight: '8px' }}>Initial Assessment Question</span>
              <span style={{ marginRight: '88px' }}>&nbsp;&nbsp;</span>
              <Switch
                name="initialAssessmentQuestion"
                onChange={handleIAQToggle}
                defaultChecked={modalShow?.triageSettings?.initialAssessmentQuestion}
              />
            </Col>
          </Row>

        </div>




        {/* Telephony Setting start */}
        <div
          style={{ display: selectedTab === "Telephony" ? "block" : "none" }}
        >
          <div>
            <span>Add DNI numbers related to this organization</span>
            <hr />
          </div>
          {formik?.values?.dni?.map((phoneNumber, index) => {
            return (
              <Row>
                <Col style={{ marginTop: "20px" }}>
                  <TextInput
                    keyField={`dni[${index}]`}
                    label={"Phone Number"}
                    formik={formik}
                    placeholder={"Phone Number"}
                    tooltip={
                      "Phone Numbers can only be created at Org level. These can be assigned to service lines"
                    }
                    required={false}
                    hideRequired={true}
                    disabled={!isAdmin}
                  />
                </Col>
                {isAdmin && <Col style={{ marginTop: "20px" }}>
                  <DeleteIcon
                    onClick={() => handleRemoveDNI(index)}
                    style={{
                      cursor: "pointer",
                      color: "#c00",
                      marginTop: "40px",
                    }}
                    titleAccess="Remove"
                  />
                </Col>}
              </Row>
            );
          })}
          {isAdmin && <Button
            onClick={handleAddDNIRow}
            variant="primary"
            style={{ marginTop: "20px" }}
          >
            + Add DNI
          </Button>}
          <hr />
        </div>

        {userRoles?.includes('Super-Admin') && !loading && (
          <div style={{ display: selectedTab === "Settings" ? 'block' : 'none' }}>
            <div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
              <label style={{ fontWeight: "bold", fontSize: "20px" }}>Patient Demographics Settings:</label>
              <div style={{ marginTop: "20px", marginLeft: "20px", display: "flex", flexDirection: "row", gap: "100px" }}>
                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Patient Identifier:</label>
                    <Switch
                      name="enforceHCN"
                      onChange={() => handleSwitchChange(setEnforceHCNSwitch)}
                      checked={enforceHCNSwitch}
                    />
                    <Tooltip title="If enabled, Patient Identifier will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Patient Email:</label>
                    <Switch
                      name="enforceEmail"
                      onChange={() => handleSwitchChange(setEnforceEmailSwitch)}
                      checked={enforceEmailSwitch}
                    />
                    <Tooltip title="If enabled, email will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{   fontSize: "18px" }}>Patient Phone:</label>
                    <Switch
                      name="enforcePhone"
                      onChange={() => handleSwitchChange(setEnforcePhoneNumberSwitch)}
                      checked={enforcePhoneNumberSwitch}
                    />
                    <Tooltip title="If enabled, phone number will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>

                </div>
                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Country:</label>
                    <Switch
                      name="enforceCountry"
                      onChange={() => handleSwitchChange(setEnforceCountrySwitch)}
                      checked={enforceCountrySwitch}
                    />
                    <Tooltip title="If enabled, country will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{   fontSize: "18px" }}>Province:</label>
                    <Switch
                      name="enforceProvince"
                      onChange={() => handleSwitchChange(setEnforceProvinceSwitch)}
                      checked={enforceProvinceSwitch}
                    />
                    <Tooltip title="If enabled, province will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>City:</label>
                    <Switch
                      name="enforceCity"
                      onChange={() => handleSwitchChange(setEnforceCitySwitch)}
                      checked={enforceCitySwitch}
                    />
                    <Tooltip title="If enabled, city will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                </div>

                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Patient First Name:</label>
                    <Switch
                      name="enforceFirstName"
                      onChange={() => handleSwitchChange(setEnforceFirstNameSwitch)}
                      checked={enforceFirstNameSwitch}
                    />
                    <Tooltip title="If enabled, first name will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Patient Last Name:</label>
                    <Switch
                      name="enforceLastName"
                      onChange={() => handleSwitchChange(setEnforceLastNameSwitch)}
                      checked={enforceLastNameSwitch}
                    />
                    <Tooltip title="If enabled, last name will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Gender:</label>
                    <Switch
                      name="enforceGender"
                      onChange={() => handleSwitchChange(setEnforceGenderSwitch)}
                      checked={enforceGenderSwitch}
                    />
                    <Tooltip title="If enabled, gender will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                </div>

                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Patient DOB:</label>
                    <Switch
                      name="enforceDob"
                      onChange={() => handleSwitchChange(setEnforceDOBSwitch)}
                      checked={enforceDOBSwitch}
                    />
                    <Tooltip title="If enabled, date of birth will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Postal Code:</label>
                    <Switch
                      name="enforcePostalCode"
                      onChange={() => handleSwitchChange(setEnforcePostalCodeSwitch)}
                      checked={enforcePostalCodeSwitch}
                    />
                    <Tooltip title="If enabled, postal code will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{   fontSize: "18px" }}>Patient Address:</label>
                    <Switch
                      name="enforceAddress"
                      onChange={() => handleSwitchChange(setEnforceAddressSwitch)}
                      checked={enforceAddressSwitch}
                    />
                    <Tooltip title="If enabled, address will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>

                </div>

              </div>
            </div>
            <div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
              <label style={{ fontWeight: "bold", fontSize: "20px" }}>Practitioner Demographics Settings:</label>
              <div style={{ marginTop: "20px", marginLeft: "20px", display: "flex", flexDirection: "row", gap: "100px" }}>
                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{ fontSize: "18px" }}>Practitioner DOB:</label>
                    <Switch
                      name="enforcePractitionerDOB"
                      onChange={() => handleSwitchChange(setEnforcePractitionerDOB)}
                      checked={enforcePractitionerDOB}
                    />
                    <Tooltip title="If enabled, DOB will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Practitioner Gender:</label>
                    <Switch
                      name="enforcePractitionerGender"
                      onChange={() => handleSwitchChange(setEnforcePractitionerGender)}
                      checked={enforcePractitionerGender}
                    />
                    <Tooltip title="If enabled, Gender will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Practitioner Address:</label>
                    <Switch
                      name="enforcePractitionerAddress"
                      onChange={() => handleSwitchChange(setEnforcePractitionerAddress)}
                      checked={enforcePractitionerAddress}
                    />
                    <Tooltip title="If enabled, Address will be a mandatory field for patient registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>

                </div>
                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Country:</label>
                    <Switch
                      name="enforcePractitionerCountry"
                      onChange={() => handleSwitchChange(setEnforcePractitionerCountry)}
                      checked={enforcePractitionerCountry}
                    />
                    <Tooltip title="If enabled, country will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{   fontSize: "18px" }}>Province:</label>
                    <Switch
                      name="enforcePractitionerProvince"
                      onChange={() => handleSwitchChange(setEnforcePractitionerProvince)}
                      checked={enforcePractitionerProvince}
                    />
                    <Tooltip title="If enabled, province will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>City:</label>
                    <Switch
                      name="enforcePractitionerCity"
                      onChange={() => handleSwitchChange(setEnforcePractitionerCity)}
                      checked={enforcePractitionerCity}
                    />
                    <Tooltip title="If enabled, city will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                </div>

                <div>
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{   fontSize: "18px" }}>Postal Code:</label>
                    <Switch
                      name="enforcePractitionerPostal"
                      onChange={() => handleSwitchChange(setEnforcePractitionerPostal)}
                      checked={enforcePractitionerPostal}
                    />
                    <Tooltip title="If enabled, postal code will be a mandatory field for practitioner registration." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                </div>


              </div>
            </div>
            <div style={{ marginTop: "20px", border: "5px solid #f0f0f0ff", padding: "10px", borderRadius: "10px", backgroundColor: "#f0f0f0ff" }}>
              <label style={{ fontWeight: "bold", fontSize: "20px" }}>Practitioner Demographics Settings:</label>
              <div style={{ marginTop: "20px", marginLeft: "20px", display: "flex", flexDirection: "row", gap: "100px" }}>
                <div>
                  
                  <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", marginBottom: "10px" }}>
                    <label style={{  fontSize: "18px" }}>Enable patient creation by AI:</label>
                    <Switch
                      name="allowPatientCreationWithAIEnabled"
                      onChange={() => handleSwitchChange(setAllowPatientCreationWithAIEnabled)}
                      checked={allowPatientCreationWithAIEnabled}
                    />
                    <Tooltip title="If enabled, AI will be able to create patient accounts." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                      <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>

                </div>
                

              </div>
            </div>
          </div>
        )}

        {/* Privacy Statements */}
        <div style={{ display: selectedTab === "Privacy Statements" ? "block" : "none"}}>
          <Row>
							<Col>
								<TextArea
									keyField={"encounterReportPrivacyStatement"}
									required={true}
									label={"Encounter Report Privacy Statement"}
									formik={formik}
									placeholder={"Type here..."}
								/>
							</Col>
						</Row>
            <Row>
							<Col>
								<TextArea
									keyField={"faxCoverPrivacyStatement"}
									required={true}
									label={"Fax Cover Letter Privacy Statement"}
									formik={formik}
									placeholder={"Type here..."}
								/>
							</Col>
						</Row>

        </div>
        

        {/* Service Line Component */}
        {selectedTab === "Service Lines" && (
          <div>
            <ListServiceLines orgdata={modalShow} />
          </div>
        )}

         <div className="btn-wrap">
          {selectedTab === tabTitles[0] && (
            <Button onClick={handleCancelClick} variant="secondary">
              {CANCEL}
            </Button>
          )}
           <Button
              type="submit"
              onClick={() => {
                if (!isLastTab) {
                  handleNext();
                }
              }}
              variant="primary"
              isLoading={btnLoading}
            >
              Save
            </Button>
        </div>
      </form>
    </section>
  );
}
